var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System/Line/Phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6491 19.9962C15.843 19.9898 15.0782 19.7855 14.3386 19.488C12.83 18.8815 11.4965 17.9854 10.2459 16.9594C8.53729 15.5572 7.04718 13.9518 5.82114 12.1104C5.04636 10.9463 4.39651 9.71773 4.11215 8.33118C3.93385 7.46139 3.93563 6.60227 4.35843 5.78443C4.55951 5.3958 4.83247 5.11358 5.25527 4.95094C5.93965 4.68758 6.60801 4.38223 7.28242 4.09218C7.69668 3.91423 7.92765 3.98648 8.15827 4.37404C8.78499 5.42712 9.40744 6.48233 10.0399 7.53185C10.2 7.79735 10.2135 8.03757 10.0601 8.31339C9.67187 9.01164 9.30103 9.71987 8.92307 10.4238C8.74869 10.7487 8.78214 10.9758 9.0455 11.2392C10.2797 12.4745 11.5147 13.7097 12.7496 14.9447C13.0276 15.2223 13.2457 15.2518 13.5941 15.0646C14.2927 14.6895 14.9956 14.3212 15.6889 13.9365C15.9576 13.7873 16.1943 13.7959 16.4548 13.9525C17.5299 14.5995 18.6104 15.2372 19.6887 15.8793C19.9767 16.0504 20.0735 16.3117 19.9428 16.6227C19.6115 17.4146 19.2727 18.2032 18.9335 18.9915C18.8012 19.299 18.5314 19.4638 18.2552 19.6179C17.7559 19.8962 17.2146 19.998 16.6491 19.9962Z",
    stroke: "#A5ACBB",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b6754a38295590a16388a595a61fb997.svg";
export { ForwardRef as ReactComponent };